import { useEffect } from "react";
import useStore from "../../hooks/useStore";
import { useDrop } from "react-dnd";

function calculateMean(numbers) {
  if (numbers.length === 0) return 0;

  let sum = numbers.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  let mean = sum / numbers.length;

  return mean;
}

function getRandomSample(arr) {
  let sampleSize = 3;
  if (sampleSize > arr.length) {
    sampleSize = arr.length;
  }
  let shuffled = arr.slice(); // Create a copy of the array
  for (let i = shuffled.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // Swap elements
  }
  return shuffled.slice(0, sampleSize);
}

function SampleList({ vals }) {
  const setPromptBoxPosition = useStore((state) => state.setPromptBoxPosition);
  const setCurrentPromptAnchor = useStore(
    (state) => state.setCurrentPromptAnchor
  );
  const setPromptIndicator = useStore((state) => state.setPromptIndicator);
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "promptbox",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
    drop(item, monitor) {
      const delta = monitor.getDifferenceFromInitialOffset();
      setPromptBoxPosition(delta.x, delta.y);
      setCurrentPromptAnchor("SampleListVal");
    },
  }));

  useEffect(() => {
    if (isOver) {
      setPromptIndicator("show more samples ... ");
    } else {
      setPromptIndicator(" ... ");
    }
  }, [isOver]);

  return (
    <div
      className="sample-val data-attr-val"
      ref={drop}
      style={{ backgroundColor: isOver ? "#4cb8df22" : "transparent" }}
    >
      {vals.map((val) => {
        return (
          <div key={val} className="sample-val-item">
            {val}
          </div>
        );
      })}
    </div>
  );
}

function CategoricalAttr({ set_vals }) {
  const vals = Array.from(set_vals);
  const C = useStore((state) => state.colors);
  const setPromptBoxPosition = useStore((state) => state.setPromptBoxPosition);
  const setCurrentPromptAnchor = useStore(
    (state) => state.setCurrentPromptAnchor
  );
  const setPromptIndicator = useStore((state) => state.setPromptIndicator);
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "promptbox",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
    drop(item, monitor) {
      const delta = monitor.getDifferenceFromInitialOffset();
      setPromptBoxPosition(delta.x, delta.y);
      setCurrentPromptAnchor("CateVal");
    },
  }));

  useEffect(() => {
    if (isOver) {
      setPromptIndicator("give me more categories ... ");
    } else {
      setPromptIndicator(" ... ");
    }
  }, [isOver]);

  return (
    <div
      className="cate-val data-attr-val"
      ref={drop}
      style={{ backgroundColor: isOver ? "#4cb8df22" : "transparent" }}
    >
      {vals.map((val, i) => {
        const c = C[i % C.length];
        return (
          <div
            key={val}
            className="cate-val-item"
            style={{ backgroundColor: c }}
          >
            {val}
          </div>
        );
      })}
    </div>
  );
}

function DescriptionAttr({ val }) {
  return <div className="desc-val data-attr-val">{val}</div>;
}

function StringAttr({ attr, data }) {
  // get all the data within the attr
  const allVals = [];
  const allCounts = [];
  // console.log(attr, data);

  if (!Array.isArray(data)) {
    return <div className="data-attr-val">..</div>;
  }

  data.forEach((d) => {
    try {
      allCounts.push(d[attr].split(" ").length);
      allVals.push(d[attr]);
    } catch (e) {
      // console.log(d[attr]);
    }
  });

  const meanWords = calculateMean(allCounts);
  if (meanWords <= 3) {
    const __temp = new Set(allVals);
    if (__temp.size === allVals.length) {
      // identical -- show a few samples
      const samples = getRandomSample(allVals);
      return <SampleList vals={samples} />;
    } else {
      // categorical -- show all the categories
      return <CategoricalAttr set_vals={__temp} />;
    }
  } else {
    // text desctiption -- show a description of the text(TODO)
    // show a single example for now
    return <DescriptionAttr val={allVals[0]} />;
  }
}

function ListAttr({ attr, data }) {
  const vals = data[0][attr];

  return (
    <div className="list-val data-attr-val">
      <span>{"["}</span>
      {vals.map((val, i) => {
        return (
          <div className="list-val-item" key={i}>
            {val}
          </div>
        );
      })}
      <span>{"]"}</span>
    </div>
  );
}

function ObjectAttr({ obj }) {
  return (
    <div className="obj-val data-attr-val">
      {Object.keys(obj).map((k, i) => {
        return (
          <div className="obj-val-item" key={i}>
            <span className="obj-key">{k}</span>
            <span className="obj-val">{JSON.stringify(obj[k])}</span>
          </div>
        );
      })}
    </div>
  );
}

export { StringAttr, ListAttr, ObjectAttr };
